export const categories = [
  { id: "all", name: "全部", slug: "all" },
  { id: "action", name: "动作片", slug: "action", icon: "ri-sword-line" },
  { id: "comedy", name: "喜剧片", slug: "comedy", icon: "ri-emotion-laugh-line" },
  { id: "drama", name: "剧情片", slug: "drama", icon: "ri-movie-2-line" },
  { id: "horror", name: "恐怖片", slug: "horror", icon: "ri-ghost-line" },
  { id: "scifi", name: "科幻片", slug: "scifi", icon: "ri-rocket-line" },
  { id: "romance", name: "爱情片", slug: "romance", icon: "ri-heart-line" },
  { id: "animation", name: "动漫", slug: "animation", icon: "ri-palette-line" },
  { id: "documentary", name: "纪录片", slug: "documentary", icon: "ri-camera-3-line" },
  { id: "variety", name: "综艺", slug: "variety", icon: "ri-live-line" },
  { id: "tv", name: "电视剧", slug: "tv", icon: "ri-tv-2-line" },
];

export interface VideoItem {
  id: string;
  title: string;
  category: string;
  poster: string;
  rating: number;
  year: number;
  duration: string;
  description: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
  isVip: boolean;
}

export const videos: VideoItem[] = [
  {
    id: "v001",
    title: "星际穿越",
    category: "scifi",
    poster: "https://readdy.ai/api/search-image?query=A%20cinematic%20movie%20poster%20of%20a%20spacecraft%20flying%20through%20a%20wormhole%20with%20distant%20galaxies%20and%20stars%2C%20warm%20golden%20and%20deep%20black%20color%20palette%2C%20epic%20film%20poster%20style%2C%20clean%20background%20with%20soft%20gradients&width=600&height=800&seq=video-scifi-001&orientation=portrait",
    rating: 9.4,
    year: 2014,
    duration: "169分钟",
    description: "一部震撼人心的科幻巨制，讲述一群探险家穿越虫洞为人类寻找新家园的故事。",
    tags: ["科幻", "冒险", "剧情"],
    isHot: true,
    isNew: false,
    isVip: false,
  },
  {
    id: "v002",
    title: "功夫",
    category: "action",
    poster: "https://readdy.ai/api/search-image?query=A%20Chinese%20martial%20arts%20movie%20poster%20with%20dynamic%20kung%20fu%20pose%20silhouette%20against%20warm%20sunset%20orange%20sky%2C%20vintage%20film%20aesthetic%2C%20dramatic%20lighting%2C%20cinematic%20composition&width=600&height=800&seq=video-action-002&orientation=portrait",
    rating: 8.7,
    year: 2004,
    duration: "99分钟",
    description: "周星驰经典动作喜剧，小人物的功夫梦，笑中带泪的精彩演绎。",
    tags: ["动作", "喜剧", "经典"],
    isHot: true,
    isNew: false,
    isVip: false,
  },
  {
    id: "v003",
    title: "千与千寻",
    category: "animation",
    poster: "https://readdy.ai/api/search-image?query=A%20Studio%20Ghibli%20style%20animated%20film%20poster%20featuring%20a%20young%20girl%20in%20a%20magical%20spirit%20world%20bathhouse%2C%20warm%20golden%20and%20soft%20pastel%20colors%2C%20hand-drawn%20aesthetic%2C%20calm%20and%20mysterious%20atmosphere&width=600&height=800&seq=video-anime-003&orientation=portrait",
    rating: 9.4,
    year: 2001,
    duration: "125分钟",
    description: "宫崎骏不朽经典，少女千寻在神灵世界中的奇妙冒险，温暖治愈心灵。",
    tags: ["动画", "奇幻", "治愈"],
    isHot: true,
    isNew: false,
    isVip: false,
  },
  {
    id: "v004",
    title: "速度与激情10",
    category: "action",
    poster: "https://readdy.ai/api/search-image?query=A%20high-octane%20action%20movie%20poster%20with%20fast%20cars%20racing%20through%20city%20streets%20at%20night%2C%20warm%20amber%20street%20lights%20and%20neon%20reflections%2C%20explosive%20dynamic%20composition%2C%20blockbuster%20style&width=600&height=800&seq=video-action-004&orientation=portrait",
    rating: 7.8,
    year: 2025,
    duration: "141分钟",
    description: "家族传奇再续新章，极限飙车燃爆银幕，前所未有的速度对决。",
    tags: ["动作", "飙车", "冒险"],
    isHot: false,
    isNew: true,
    isVip: true,
  },
  {
    id: "v005",
    title: "你好，李焕英",
    category: "comedy",
    poster: "https://readdy.ai/api/search-image?query=A%20warm%20Chinese%20family%20comedy%20film%20poster%20with%20mother%20and%20daughter%20smiling%20in%20retro%201980s%20Chinese%20factory%20setting%2C%20soft%20warm%20golden%20light%2C%20nostalgic%20and%20touching%20mood%2C%20clean%20composition&width=600&height=800&seq=video-comedy-005&orientation=portrait",
    rating: 8.1,
    year: 2021,
    duration: "128分钟",
    description: "贾玲导演处女作，穿越时空与年轻母亲相遇，笑泪交织的亲情故事。",
    tags: ["喜剧", "亲情", "穿越"],
    isHot: true,
    isNew: false,
    isVip: false,
  },
  {
    id: "v006",
    title: "釜山行",
    category: "horror",
    poster: "https://readdy.ai/api/search-image?query=A%20Korean%20zombie%20thriller%20movie%20poster%20with%20tense%20survivors%20on%20a%20moving%20train%2C%20dark%20moody%20atmosphere%20with%20warm%20emergency%20light%20accents%2C%20suspenseful%20cinematic%20composition&width=600&height=800&seq=video-horror-006&orientation=portrait",
    rating: 8.5,
    year: 2016,
    duration: "118分钟",
    description: "韩国丧尸灾难片巅峰之作，列车上的人性考验，紧张刺激全程无尿点。",
    tags: ["恐怖", "灾难", "人性"],
    isHot: false,
    isNew: false,
    isVip: false,
  },
  {
    id: "v007",
    title: "泰坦尼克号",
    category: "romance",
    poster: "https://readdy.ai/api/search-image?query=A%20classic%20romantic%20film%20poster%20with%20a%20couple%20embracing%20on%20a%20ship%20bow%20at%20sunset%2C%20warm%20golden%20orange%20sky%2C%20epic%20romantic%20cinematic%20style%2C%20soft%20dreamy%20atmosphere&width=600&height=800&seq=video-romance-007&orientation=portrait",
    rating: 9.4,
    year: 1997,
    duration: "194分钟",
    description: "不朽的爱情传奇，杰克与露丝在泰坦尼克号上的生死之恋，感动全球观众。",
    tags: ["爱情", "灾难", "经典"],
    isHot: true,
    isNew: false,
    isVip: false,
  },
  {
    id: "v008",
    title: "盗梦空间",
    category: "scifi",
    poster: "https://readdy.ai/api/search-image?query=A%20mind-bending%20sci-fi%20movie%20poster%20with%20folding%20cityscapes%20and%20layered%20dreams%2C%20warm%20amber%20and%20deep%20charcoal%20tones%2C%20surreal%20architectural%20composition%2C%20philosophical%20thriller%20aesthetic&width=600&height=800&seq=video-scifi-008&orientation=portrait",
    rating: 9.3,
    year: 2010,
    duration: "148分钟",
    description: "诺兰的梦境迷宫，层层嵌套的潜意识冒险，烧脑又震撼的视觉盛宴。",
    tags: ["科幻", "悬疑", "烧脑"],
    isHot: true,
    isNew: false,
    isVip: false,
  },
  {
    id: "v009",
    title: "地球脉动III",
    category: "documentary",
    poster: "https://readdy.ai/api/search-image?query=A%20nature%20documentary%20film%20poster%20featuring%20stunning%20wildlife%20and%20landscapes%20from%20around%20the%20world%2C%20warm%20earthy%20tones%2C%20breathtaking%20aerial%20photography%20style%2C%20clean%20educational%20aesthetic&width=600&height=800&seq=video-doc-009&orientation=portrait",
    rating: 9.8,
    year: 2024,
    duration: "每集60分钟",
    description: "BBC自然纪录片巅峰，用镜头记录地球最壮丽的自然奇观与生命故事。",
    tags: ["自然", "纪录", "BBC"],
    isHot: false,
    isNew: true,
    isVip: false,
  },
  {
    id: "v010",
    title: "甄嬛传",
    category: "tv",
    poster: "https://readdy.ai/api/search-image?query=A%20Chinese%20historical%20palace%20drama%20poster%20with%20elegant%20woman%20in%20traditional%20Qing%20dynasty%20costume%2C%20warm%20golden%20palace%20interior%20lighting%2C%20classical%20Chinese%20aesthetic%2C%20regal%20composition&width=600&height=800&seq=video-tv-010&orientation=portrait",
    rating: 9.3,
    year: 2011,
    duration: "76集",
    description: "宫斗剧天花板，甄嬛从纯真少女到后宫之主的传奇蜕变，百看不厌。",
    tags: ["古装", "宫斗", "经典"],
    isHot: false,
    isNew: false,
    isVip: true,
  },
  {
    id: "v011",
    title: "狂飙",
    category: "tv",
    poster: "https://readdy.ai/api/search-image?query=A%20Chinese%20crime%20drama%20TV%20series%20poster%20with%20tense%20police%20and%20underworld%20confrontation%2C%20dark%20moody%20atmosphere%20with%20warm%20streetlight%20accents%2C%20gritty%20realistic%20style%2C%20dramatic%20composition&width=600&height=800&seq=video-tv-011&orientation=portrait",
    rating: 8.5,
    year: 2023,
    duration: "39集",
    description: "年度现象级扫黑剧，二十年正邪较量，张颂文演技封神之作。",
    tags: ["犯罪", "剧情", "扫黑"],
    isHot: true,
    isNew: false,
    isVip: false,
  },
  {
    id: "v012",
    title: "王牌对王牌",
    category: "variety",
    poster: "https://readdy.ai/api/search-image?query=A%20Chinese%20variety%20show%20poster%20with%20colorful%20stage%20lights%20and%20celebrity%20hosts%20in%20a%20fun%20game%20show%20setting%2C%20bright%20warm%20stage%20lighting%2C%20entertaining%20and%20lively%20atmosphere%2C%20TV%20show%20aesthetic&width=600&height=800&seq=video-variety-012&orientation=portrait",
    rating: 7.9,
    year: 2025,
    duration: "每期90分钟",
    description: "国民级综艺节目，明星嘉宾欢乐对决，笑料不断精彩纷呈。",
    tags: ["综艺", "搞笑", "明星"],
    isHot: false,
    isNew: true,
    isVip: false,
  },
];

export const heroVideos: VideoItem[] = [
  {
    id: "hero-01",
    title: "阿凡达：火与烬",
    category: "scifi",
    poster: "https://readdy.ai/api/search-image?query=A%20breathtaking%20cinematic%20landscape%20of%20an%20alien%20world%20with%20floating%20mountains%20and%20bioluminescent%20forests%2C%20warm%20golden%20sunset%20light%2C%20epic%20fantasy%20film%20atmosphere%2C%20immersive%20wide%20cinematic%20shot&width=1600&height=700&seq=hero-bg-avatar&orientation=landscape",
    rating: 8.9,
    year: 2025,
    duration: "192分钟",
    description: "重返潘多拉星球，开启全新史诗冒险，视觉奇观全面升级。",
    tags: ["科幻", "冒险", "3D"],
    isHot: true,
    isNew: true,
    isVip: true,
  },
];